export default [
  {
    path: '/article/teacher-index/:id',
    name: 'teacher-article',
    component: () => import('@/views/empty/terms-and-conditions/Teacher.vue'),
    meta: { layout: 'empty' },
  },
];
